<template>
  <el-dialog title="参与成员" :visible.sync="dialogVisible" :close-on-click-modal="false" :modal="false" @closed="onCancel">
    <el-alert
      v-if="!countEdit"
      title="您不在此项目中，如想进入该项目，请联系该项目中的同事"
      style="margin-bottom:10px;"
      type="warning">
    </el-alert>
    <div class="flex-row mb5">
      <div class="col-0 propject_detail_info_label mr5">客户开发</div>
      <div class="col-1 flex-row flex-wrap flex_wrap_container">
        <div v-for="(item, index) in changes['客户开发']" :key="index" class="flex_wrap_item">
          <el-select v-model="changes['客户开发'][index]" :disabled="!countEdit" filterable size="mini">
            <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
          </el-select>
          <a v-if="countEdit" class="col-0 mr5 danger" @click="removePartner('客户开发', index)"> <i class="el-icon-remove" /> </a>
          <a v-if="countEdit && index === changes['客户开发'].length - 1" class="col-0 mr5" @click="addPartner('客户开发')">
            <i class="el-icon-circle-plus" />
          </a>
        </div>
      </div>
    </div>
    <div class="flex-row mb5">
      <div class="col-0 propject_detail_info_label mr5">项目对接</div>
      <div class="col-1 flex-row flex-wrap flex_wrap_container">
        <div v-for="(item, index) in changes['项目对接']" :key="index" class="flex_wrap_item">
          <el-select v-model="changes['项目对接'][index]" :disabled="!countEdit" filterable size="mini">
            <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
          </el-select>
          <a v-if="countEdit" class="col-0 mr5 danger" @click="removePartner('项目对接', index)"> <i class="el-icon-remove" /> </a>
          <a v-if="countEdit && index === changes['项目对接'].length - 1" class="col-0 mr5" @click="addPartner('项目对接')">
            <i class="el-icon-circle-plus" />
          </a>
        </div>
      </div>
    </div>
    <div class="flex-row mb5">
      <div class="col-0 propject_detail_info_label mr5">项目经理</div>
      <div class="col-1 flex-row flex-wrap flex_wrap_container">
        <div v-for="(item, index) in changes['项目经理']" :key="index" class="flex_wrap_item">
          <el-select v-model="changes['项目经理'][index]" :disabled="!countEdit" filterable size="mini">
            <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
          </el-select>
          <a v-if="countEdit" class="col-0 mr5 danger" @click="removePartner('项目经理', index)"> <i class="el-icon-remove" /> </a>
          <a v-if="countEdit && index === changes['项目经理'].length - 1" class="col-0 mr5" @click="addPartner('项目经理')">
            <i class="el-icon-circle-plus" />
          </a>
        </div>
      </div>
    </div>
    <div class="flex-row mb5">
      <div class="col-0 propject_detail_info_label mr5">项目成员</div>
      <div class="col-1 flex-row flex-wrap flex_wrap_container">
        <div v-for="(item, index) in changes['项目成员']" :key="index" class="flex_wrap_item">
          <el-select v-model="changes['项目成员'][index]" :disabled="!countEdit" filterable size="mini">
            <el-option v-for="(value, i) in accounts" :key="i" :value="value" :label="value" />
          </el-select>
          <a v-if="countEdit" class="col-0 mr5 danger" @click="removePartner('项目成员', index)"> <i class="el-icon-remove" /> </a>
          <a v-if="countEdit && index === changes['项目成员'].length - 1" class="col-0 mr5" @click="addPartner('项目成员')">
            <i class="el-icon-circle-plus" />
          </a>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" class="mr10" type="danger" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
const dateFormat = require('dateformat')

export default {
  data() {
    return {
      changes: {},
      dialogVisible: false,
      countEdit:false,
    }
  },
  computed: {
    accounts() {
      return window.app.accounts || []
    },
  },

  methods: {
    onCancel() {
      this.dialogVisible = false
      this.cancelEdit({
        客户开发: true,
        项目对接: true,
        项目经理: true,
        项目成员: true,
      })
    },
    cancelEdit(params) {
      const fields = Object.keys(params)
      fields.forEach(field => {
        delete this.changes[field]
      })
      this.changes = Object.assign({}, this.changes)
    },
    onConfirm() {
      if(!this.countEdit) {
        this.dialogVisible = false
      }else{
        const { changes } = this
        this.updateProject({
          客户开发: (changes['客户开发'] && changes['客户开发'].filter(Boolean)) || [],
          项目对接: (changes['项目对接'] && changes['项目对接'].filter(Boolean)) || [],
          项目经理: (changes['项目经理'] && changes['项目经理'].filter(Boolean)) || [],
          项目成员: (changes['项目成员'] && changes['项目成员'].filter(Boolean)) || [],
        })
        this.dialogVisible = false
      }
    },
    async updateProject(param, cb) {
      if (!this.project._id) return
      try {
        await window.app.service('project').modify({
          id: this.project._id,
          param,
        })
        Object.assign(this.project, param)
        // this.$emit('updateProject', param)
        cb && cb()
        this.cancelEdit(param)
        this.$message({ type: 'success', message: `修改成功` })
      } catch (e) {
        this.$message.error(`update project :${e.message}`)
      }
    },
    open(project) {
      // const project = this.project
      this.project = project
      const fields = ['客户开发', '项目对接', '项目经理', '项目成员']
      fields.forEach(field => {
        const value = (project[field] && project[field].slice()) || ['']
        this.$set(this.changes, field, value)
        if (this.changes[field].length === 0) this.changes[field].push('')
      })
      this.checkPermission()
      this.dialogVisible = true
    },
    checkPermission(){
      // const isAdmin = Array.isArray(app.user.角色) && app.user.角色.includes('管理员')
      const isAdmin = false
      const account = app.user.account
      let inProject = false
      const fields = ['客户开发', '项目对接', '项目经理', '项目成员']
      fields.forEach(field => {
        if (this.changes[field].includes(account)){
          inProject = true
        }
      })
      this.countEdit = isAdmin || inProject
    },
    addPartner(field) {
      const value = this.changes[field] || []
      const length = value.length
      if (length === 0 || value[length - 1]) {
        value.push('')
      }
      this.changes = Object.assign({}, this.changes, { [field]: value })
    },
    removePartner(field, index) {
      const value = this.changes[field] || []
      value.splice(index, 1)
      if (value.length === 0) value.push('')
      this.changes = Object.assign({}, this.changes, { [field]: value })
    },
  },
}
</script>
